import { useState } from "react";
//-------------- Antd --------------\\
import { Button } from "antd";
import {
  MessageOutlined,
  LoadingOutlined,
  SmileOutlined,
  SolutionOutlined,
  UserOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

//-------------- Components --------------\\
import FormDados from "./FormDados";
import FormInformacao from "./FormInformacao";
import FormMaisInfo from "./FormMaisInfo";
import FormSMS from "./FormSMS";
import Feedback from "./Feedback";
import FormInteresse from "./FormInteresse";
import FormMaisInteresse from "./FormMaisInteresse";
//-------------- Styles --------------\\
import { CardStyle, StepsStyle, ContainerButton } from "../styles";

//-------------- Constants --------------\\
import { handleBack } from "../constants/handleBack";
import { handleNext } from "../constants/handleNext";

//-------------- Interfaces --------------\\
import { Leads } from "../../../interfaces/Leads";
import { SMS } from "../Interface/Sms";

//-------------- Hooks --------------\\
import { useSms } from "../hooks/useSms";
import { useCadastrarPostagem } from "../../ViewGerenciarPostagens/hooks/useCadastrarPostagem";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { Interesse } from "../Interface/Interesse";
import { Informacao } from "../Interface/Informacao";

export default function CardPostagem() {
  const [activeStep, setActiveStep] = useState<number>(0);
  const [renderInteresse, setRenderInteresse] = useState<number>(1);

  const [bloquearBtn, setBloquearBtn] = useState<boolean>(true);

  const [formData, setFormData] = useState<Partial<Leads>>({});
  const [formSms, setFormSms] = useState<Partial<SMS>>({});
  const [formInteresse, setFormInteresse] = useState<Partial<Interesse>>({});
  const [formMaisInteresse, setFormMaisInteresse] = useState<
    Partial<Interesse>
  >({});
  const [formInfo, setFormInfo] = useState<Partial<Informacao>>({});
  const [formMaisInfo, setFormMaisInfo] = useState<Partial<Informacao>>({});

  const { enviaSms, verificaSms } = useSms();
  const { cadastrar } = useCadastrarPostagem();

  const { showSuccess, showError, showWarning, contextHolder } = useMessage();

  const [stepsStatus, setStepsStatus] = useState<
    Array<"wait" | "process" | "finish" | "error">
  >([
    "process", // 0
    "wait", // 1
    "wait", // 2
    "wait", // 3
    "wait", //4
  ]);

  return (
    <CardStyle>
      <StepsStyle
        items={[
          {
            title: "Dados",
            status: stepsStatus[0],
            icon:
              stepsStatus[0] === "finish" ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <UserOutlined />
              ),
          },
          {
            title: "Verificação",
            status: stepsStatus[1],
            icon:
              stepsStatus[1] === "finish" ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : stepsStatus[1] === "process" ? (
                <LoadingOutlined spin />
              ) : (
                <MessageOutlined />
              ),
          },

          {
            title: "Interesse",
            status: stepsStatus[2],
            icon:
              stepsStatus[2] === "finish" ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <SolutionOutlined />
              ),
          },
          {
            title: "Informação",
            status: stepsStatus[3],
            icon:
              stepsStatus[3] === "finish" ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <SolutionOutlined />
              ),
          },
          {
            title: "Conclusão",
            status: stepsStatus[4],
            icon:
              stepsStatus[4] === "finish" ? (
                <CheckCircleOutlined style={{ color: "green" }} />
              ) : (
                <SmileOutlined />
              ),
          },
        ]}
      />
      {/* {Dados} */}
      {activeStep === 0 && (
        <FormDados
          setFormData={setFormData}
          formData={formData}
          onValidChange={(valido) => setBloquearBtn(!valido)}
        />
      )}

      {/* {Verficação} */}
      {activeStep === 1 && (
        <FormSMS
          setFormSms={setFormSms}
          formData={formData}
          enviaSms={enviaSms}
          onValidChange={(valido) => setBloquearBtn(!valido)}
        />
      )}

      {/* {Interesse} */}
      {activeStep === 2 && (
        <>
          {renderInteresse === 1 && (
            <FormInteresse
              setFormInteresse={setFormInteresse}
              formInteresse={formInteresse}
              onValidChange={(valido) => setBloquearBtn(!valido)}
            />
          )}
          {renderInteresse === 2 && (
            <FormMaisInteresse
              setFormMaisInteresse={setFormMaisInteresse}
              formMaisInteresse={formMaisInteresse}
              onValidChange={(valido) => setBloquearBtn(!valido)}
            />
          )}
        </>
      )}

      {/* {Informação} */}
      {activeStep === 3 && (
        <FormInformacao
          setFormInfo={setFormInfo}
          formInfo={formInfo}
          onValidChange={(valido) => setBloquearBtn(!valido)}
        />
      )}

      {/* {Divulgação} */}
      {activeStep === 4 && (
        <FormMaisInfo
          setFormMaisInfo={setFormMaisInfo}
          formMaisInfo={formMaisInfo}
          onValidChange={(valido) => setBloquearBtn(!valido)}
        />
      )}

      {/* {Feedback} */}
      {activeStep === 5 && <Feedback />}

      <ContainerButton>
        {contextHolder}
        <Button
          disabled={activeStep === 0 || activeStep === 5}
          onClick={() =>
            handleBack(
              activeStep,
              setActiveStep,
              stepsStatus,
              setStepsStatus,
              renderInteresse,
              setRenderInteresse
            )
          }
        >
          Voltar
        </Button>

        <Button
          disabled={bloquearBtn}
          onClick={() =>
            handleNext(
              activeStep,
              setActiveStep,
              stepsStatus,
              setStepsStatus,
              setBloquearBtn,
              formData,
              enviaSms,
              formSms,
              verificaSms,
              formInteresse,
              formMaisInteresse,
              formInfo,
              formMaisInfo,
              cadastrar,
              showSuccess,
              showWarning,
              showError,
              renderInteresse,
              setRenderInteresse
            )
          }
        >
          {activeStep === 4
            ? "Cadastrar"
            : activeStep === 5
            ? "Finalizar"
            : "Próximo"}
        </Button>
      </ContainerButton>
    </CardStyle>
  );
}
